import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=52950e9a&scoped=true&"
import script from "./Update.vue?vue&type=script&lang=js&"
export * from "./Update.vue?vue&type=script&lang=js&"
import style0 from "./Update.vue?vue&type=style&index=0&id=52950e9a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52950e9a",
  null
  
)

export default component.exports